import { ProjectService } from '@/api/project';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { Button, Dialog, Modal, ModalRef } from 'alurkerja-ui';
import React, { useRef } from 'react';
import { FaTrash } from 'react-icons/fa';

type DeleteProjectProps = {
  id: string;
  onSuccess: () => void;
};

export const DeleteProject: React.FC<DeleteProjectProps> = ({
  id,
  onSuccess,
}) => {
  const ref = useRef<ModalRef>(null);
  const { mutate: deleteMutate, isPending: isDeleteLoading } =
    ProjectService.useDelete();

  const deleteAction = (id: string) => {
    deleteMutate(id, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Project has been deleted',
          callback: () => {
            onSuccess();
            ref.current?.closeModal();
          },
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to delete Project',
        });
      },
    });
  };

  return (
    <Modal
      ref={ref}
      triggerButton={
        <Button
          className="bg-red-600"
        >
          <FaTrash />
        </Button>
      }
      title="Delete Project"
    >
      {({ closeModal }) => {
        return (
          <div className="flex flex-col gap-4 p-4">
            <p className="text-gray-500">
              Are you sure you want to delete this Project? This action cannot
              be undone.
            </p>

            <div className="flex flex-row gap-2">
              <OutlineButton onClick={closeModal}>Cancel</OutlineButton>

              <Button
                type="button"
                color="red"
                onClick={() => deleteAction(id)}
                loading={isDeleteLoading}
              >
                Delete
              </Button>

            </div>
          </div>
        );
      }}
    </Modal>
  );
};
